import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Home from "../screens/auth/Home";
import CarrierAccess from "../screens/auth/CarrierAccess";
import Scripts from "../screens/auth/Scripts";
import AgentResources from "../screens/auth/AgentResources";
import Training from "../screens/auth/Training";
import CancelationFormDirectory from "../screens/auth/CancelationFormDirectory";
import CarrierContacts from "../screens/auth/CarrierContacts";

export const authRoutes = [
  {
    path: "/home",
    component: <Home />,
  },
  {
    path: "/carrier-login",
    component: <CarrierAccess />,
  },
  {
    path: "/scripts",
    component: <Scripts />,
  },
  {
    path: "/agent-resources",
    component: <AgentResources />,
  },
  {
    path: "/training",
    component: <Training />,
  },
  {
    path: "/cancelation-form-directory",
    component: <CancelationFormDirectory />,
  },
  {
    path: "/carrier-contacts",
    component: <CarrierContacts />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/",
    component: <Login />,
  },
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];
